import { Component, OnInit, Input } from '@angular/core';
import { modalDialogEvent, propertyFormModel } from "../../../../../components/SchemaPropertyNode";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-schema-property-edit',
  template: `<div class="modal-header">
  <h6 class="modal-title">Add {{propertyFormModel.formTitle}}</h6>
  <button type="button" class="close" (click)="activeModal.dismiss('Cross click')">&times;</button>

</div>
<div class="modal-body form-inline homecoming">
  <form #propertyEditForm="ngForm">
    <div class="row">
      <div class="form-group col-md-7">
        <label>Property Name:</label>
        <input type="text" name="propName" [disabled]="propertyFormModel.formType==='array'" [(ngModel)]="propertyFormModel.propName" placeholder="Enter Property Name" class="form-control"
        />
      </div>
      <div class="form-group col-md-5">
        <label>Data Type:</label>
        <select class="form-control" title="Select" name="propType" [(ngModel)]="propertyFormModel.propType">
                                    <option value="" selected> Select</option>
                                    <option value="string"> String</option>
                                    <option value="number"> Number</option>
                                    <option value="object"> Object</option>
                                    <option value="array"> Collection</option>
                                </select>
      </div>

    </div>
    <br/>
    <div class="row">
      <div class="form-group col-md-8">
        <label>Description: </label>
        <input type="text" class="form-control" name="description" [(ngModel)]="propertyFormModel.description" />
      </div>
      <div class="form-group col-md-4">
        <label>Is Required:</label>
        <input type="checkbox" name="isRequeried" class="form-control" [checked]="propertyFormModel.isRequeried" (change)="propertyFormModel.isRequeried=!propertyFormModel.isRequeried"
        />
      </div>

    </div>

  </form>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="!propertyEditForm.form.valid" (click)="doActionOnSuccessEvent()">Add</button>
  <button type="button" class="btn btn-outline-dark" (click)="doActionOnCloseEvent()">Close</button>
</div>`,
  styles: [`.modal-backdrop{z-index:1050}`]
})
export class SchemaPropertyEditComponent implements OnInit {

  @Input() propertyNode: modalDialogEvent;

  @Input() propertyFormModel: propertyFormModel;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
  doActionOnSuccessEvent() {
    this.propertyNode.doActionOnSuccessEvent(null);
    this.activeModal.close('Close click');
  }
  doActionOnDismissEvent() {
    this.activeModal.dismiss('Cross click');
  }
  doActionOnCloseEvent() {
    this.propertyNode.doActionOnDismissEvent();
    this.activeModal.close('Close click');
  }

}
